module.exports = __webpack_public_path__ + "img/0118be6.png";